import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { default as Actions } from '../actions';
import * as CommonActions from '../../common/actions';
import { withSession } from '../../i18n/containers/AppInit.js';

import './Home.scss';

import { BrandBand } from '../../common/components';
import { AssetAttributeList, Header, McMenu } from '../components/';

export class AssetAttributeDashboard extends Component {
  componentDidMount() {
    this.props.actions.getAttributes();
    this.props.actions.getRules();
  }

  handleListAction(session) {
    return (action, attr, disabled) => {
      const attribute = { ...attr };
      if (!attribute?.values?.length) {
        attribute.values = [''];
      }
      switch (action) {
        case 'edit':
          const modalName = attribute.type.startsWith('Weather')
            ? 'weatherAttributeEdit'
            : 'attributeEdit';
          this.props.actions.openModal(modalName, {
            attribute,
            // deep copy the object without lodash or structuredClone
            original: JSON.parse(JSON.stringify(attribute))
          });
          break;
        case 'delete':
          if (disabled) {
            break;
          }
          this.props.actions.deleteAttribute(attribute, {
            callback: this.props.actions.getAttributes,
            cToken: session.cToken
          });
          break;
        default:
          break;
      }
    };
  }

  render() {
    const {
      assetAttributes,
      weatherAttributes,
      filter,
      lastSave
    } = this.props.attributes.data;
    const { isLoading, isSaving } = this.props.attributes;
    const attributeList = [...assetAttributes, ...weatherAttributes];

    attributeList.sort((a, b) => a.name.localeCompare(b.name));

    return withSession(session => {
      return (
        <McMenu
          flags={this.props.flags}
          history={this.props.history}
          route="/attributes/asset"
        >
          <BrandBand>
            <Header route={this.props.match} />
            <AssetAttributeList
              actions={this.props.actions}
              attributes={attributeList || []}
              filter={filter}
              flags={this.props.flags?.flags}
              isLoading={isLoading}
              isSaving={isSaving}
              lastSave={lastSave}
              onListAction={this.handleListAction(session)}
              modals={this.props.modals}
              rules={this.props.rules.data.rules}
              toast={this.props.toast}
              location={this.props.location}
            />
          </BrandBand>
        </McMenu>
      );
    });
  }
}

AssetAttributeDashboard.contextTypes = {
  router: PropTypes.object
};

AssetAttributeDashboard.propTypes = {
  actions: PropTypes.shape({
    getAttributes: PropTypes.func,
    openModal: PropTypes.func
  }),
  attributes: PropTypes.object.isRequired,
  flags: PropTypes.object,
  modals: PropTypes.object,
  rules: PropTypes.object,
  toast: PropTypes.object,
  location: PropTypes.object
};

function mapStateToProps(state) {
  return {
    attributes: state.ecs.attributes,
    flags: state.ecs.flags,
    modals: state.modals,
    rules: state.ecs.rules,
    toast: state.toast
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...Actions, ...CommonActions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssetAttributeDashboard);
